import { render } from "./SelectLanguage.vue?vue&type=template&id=3b6d0c5b&scoped=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=js"
export * from "./SelectLanguage.vue?vue&type=script&lang=js"

import "@/assets/scss/_selectLanguage.scss?vue&type=style&index=0&id=3b6d0c5b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6d0c5b"]])

export default __exports__